import { RoleTypeService } from "../../services/RoleTypeService";
import {
    SET_LOADING,
    SET_ROLE_TYPE_LIST,
} from "./types";

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to set loading
 */
export const setLoading = (data) => ({
    type: SET_LOADING,
    payload: data
});

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to set Role Type list
 */
export const setRoleTypeList = (data) => ({
    type: SET_ROLE_TYPE_LIST,
    payload: data
});

/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @description to get Role Type list
 */
export const getRoleTypeList = (successCallback, errorCallback) => async (dispatch) => {
    await dispatch(setLoading(true));
    await RoleTypeService.getRoleTypeList().then(async (res) => {
        console.log("Result: ", res);
        await dispatch(setRoleTypeList(res?.data[0]));
        successCallback?.();
    }).catch(async (err) => {
        console.log("Role Type list Error: ", err);
        errorCallback?.(err);
    }).finally(() => {
        dispatch(setLoading(false));
    })
};